import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { FileText, Package, ShoppingBag, Shirt, Scissors, Mail, AlertTriangle } from "lucide-react";

export default function Dashboard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)).catch(() => setS({})); }, []);

  const cards = [
    { label: "New Custom Requests", value: s?.new_requests, icon: FileText, to: "/admin/requests", accent: true },
    { label: "Pending Orders", value: s?.pending_orders, icon: Package, to: "/admin/orders" },
    { label: "Products", value: s?.products, icon: ShoppingBag, to: "/admin/products" },
    { label: "Styles", value: s?.styles, icon: Shirt, to: "/admin/styles" },
    { label: "Fabrics", value: s?.fabrics, icon: Scissors, to: "/admin/fabrics" },
    { label: "Unread Messages", value: s?.messages, icon: Mail, to: "/admin/inbox" },
  ];

  return (
    <div>
      <h1 className="font-serif text-3xl text-kys-ink sm:text-4xl">Welcome back</h1>
      <p className="mt-1 text-sm text-kys-muted">Manage your boutique — everything here updates the live site.</p>

      {s?.low_stock > 0 && (
        <div className="mt-5 flex items-center gap-2 rounded-md border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800">
          <AlertTriangle className="h-4 w-4" /> {s.low_stock} product(s) are low or out of stock.
        </div>
      )}

      <div className="mt-6 grid grid-cols-2 gap-4 md:grid-cols-3">
        {cards.map((c) => (
          <Link key={c.label} to={c.to} data-testid={`stat-${c.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
            className={`rounded-lg border p-5 transition hover:shadow-md ${c.accent && c.value > 0 ? "border-kys-accent bg-kys-blush" : "border-kys-blush-border bg-white"}`}>
            <c.icon className="h-5 w-5 text-kys-accent" />
            <p className="mt-3 font-mono text-3xl text-kys-ink">{c.value ?? "—"}</p>
            <p className="mt-1 text-xs text-kys-muted">{c.label}</p>
          </Link>
        ))}
      </div>

      <div className="mt-8 rounded-lg border border-kys-blush-border bg-white p-6">
        <h2 className="font-serif text-xl text-kys-ink">Getting started</h2>
        <ul className="mt-3 space-y-2 text-sm text-kys-charcoal">
          <li>• Replace the <strong>[SAMPLE]</strong> products and fabrics with your real items.</li>
          <li>• Upload photos to your <Link to="/admin/styles" className="text-kys-accent underline">Style Library</Link> and set <Link to="/admin/compatibility" className="text-kys-accent underline">design ↔ fabric availability</Link>.</li>
          <li>• Fill in your business info, policies & FAQ under <Link to="/admin/content" className="text-kys-accent underline">Content & Settings</Link>.</li>
          <li>• Payment, shipping, tax and email integrations are placeholders until you connect them.</li>
        </ul>
      </div>
    </div>
  );
}
